import { BREAKPOINTS } from "../ApplicationConfig";
import Slider from "../slider/Slider";
import CommonJsStorage from "../CommonJsStorage";
import ProductVariationsController, { VariationDetails } from '../product-variations/ProductVariationsController';

const Glide = require('@glidejs/glide');

export default function initProduct()
{
    initSimilarSlider();

    let sliderNode      = document.getElementById('product-documents-slider') as HTMLElement;
    let commonStorage   = new CommonJsStorage(window['commonStore'] || {});
    let hiddenSpecifications = document.querySelectorAll('.product-card__specification_hidden');

    if (commonStorage.get('isMobile') == true) {
        initVariantsSlider();
    }

    document.querySelectorAll('.js-show-hidden-specifications').forEach(control => {
        let button = control as HTMLElement;

        button.addEventListener('click', () => {
            hiddenSpecifications.forEach(node => {
                let item = node as HTMLElement;
                item.classList.toggle('product-card__specification_hidden');
                item.classList.toggle('product-card__visible');
            });

            button.classList.toggle('expander__button-opened');
            button.innerText = button.classList.contains('expander__button-opened') ? 'Скрыть' : 'Все характеристики';
        });
    });

    loadProductVariations();
}

function initSimilarSlider()
{
    let leadersBreakpoints = {}
    leadersBreakpoints[BREAKPOINTS.SM] = {perView: 1, hideNavArrows: true, gap: 10, withShadow: false};
    leadersBreakpoints[BREAKPOINTS.LG] = {perView: 2, hideNavArrows: true};
    leadersBreakpoints[1400] = {perView: 3, hideNavArrows: false};

    new Slider('#similar-products-slider', {
        type: 'slider',
        bound: true,
        rewindDuration: 500,
        perView: 4,
        gap: 0,
        keyboard: false,
        useScrollableDots: true,
        hideNavArrows: false,
        breakpoints: leadersBreakpoints,
        loadAllSlidesByObserver: true,
        withShadow: true
    });
}

function initVariantsSlider()
{
    new Slider('#product-card-variants', {
        type: 'carousel',
        perView: 1,
        gap: 20,
        keyboard: false,
        useScrollableDots: true,
        hideNavArrows: true,
        loadAllSlidesByObserver: false,
        adaptiveHeight: true,
    });
}

function loadProductVariations()
{
    let productVariations = window['productCardVariations'];
    if (typeof productVariations !== 'undefined') {
        let container = document.querySelector('.js-product-variations-buttons');
        let firstVariationKey = Object.keys(productVariations)[0];

        if (
            !container
            || typeof productVariations[firstVariationKey] === 'undefined'
            || Object.keys(productVariations[firstVariationKey]).length <= 1
        ) {
            return;
        }

        let loading = false;

        try {
            let variationsController = new ProductVariationsController(container);
            variationsController.appendVariations(productVariations);
        } catch (e) {
            console.error(e);
        }

        document.body.addEventListener('product-variations-switched', (evt) => {
            let e = evt as CustomEvent;
            let eventData = e.detail as VariationDetails;

            if (!loading) {
                loading = true;
                window.location = eventData.variation.url;
            }
        });
    }
}